import React, { useState,useEffect  } from 'react';
import '../../../style/google_forms.css';
import DynamicTable2 from "../../components/DynamicTable2";
import { EmailInput, RadioButtonInput, PhoneNumberInput } from '../../components/FormInitiators';
import { Loader } from "lucide-react";
import { useFormSubmission } from "../../pages/payment/withoutpayment";



function DaArrearsForm() {
  const initialFormState = {
    employeeName: "",
    officeName: "",
    email: "",
    gender: "",
    handicapped: "",
    phoneNumber: "",
    professionalTax: "",
    designation: "",
    SalaryDetails: [],
    arrearsEndDate: "",
    city: "",
  };
  const dummyFormData = {
    employeeName: "SHRI. CHINMAY BALKRISHNA SURVE",
    officeName: "LBS COLLEGE SATARA",
    email: "survechinmay6@gmail.com",
    gender: "male",
    handicapped: "No",
    phoneNumber: "9406546508",
    professionalTax: "Yes",
    designation: "Software Engineer",
    SalaryDetails: [
      {date:"", basicPay: 5000, payLevel: "S-1" },
    ],
    arrearsEndDate: "2024-12-31",
    city: "X",
  };
  
  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("SalaryDetails")) || [];
    setFormData((prev) => ({ ...prev, SalaryDetails: storedData }));
  }, []);

  const [formData, setFormData] = useState(initialFormState);
  const { handleFormSubmission, isSubmitting, PaymentWindowComponent  } = useFormSubmission();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const onTableDataChange = (key) => (rows) => {
    setFormData((prev) => ({ ...prev, [key]: rows }));
  };



const formConfig = {
  apiEndpoint: `${process.env.REACT_APP_BACKEND_URL}/api/daArrearsForm/submit-daArrears`,
  paymentDescription: "Payment for D.A. Arrears Jan25 Form",
  successRoute: "/daArrearsForm/daArrears-result",
    name: formData.employeeName,
    formType: "DA_Arrears",
    email: formData.email,
    contact: formData.phoneNumber,
  onSuccessCallback: () => localStorage.clear(),
};

const handleSubmit = (e) => {
  e.preventDefault();
  handleFormSubmission(formData, formConfig);
};


  return (
    <>
    <div className="google_forms">
    
      <form className="forms" onSubmit={handleSubmit}>
        <h2>Information of Employee to Calculate D.A. Arrears from the period 01/01/2025</h2>

        <div>
          <label class="font-bold">How to fill form?
          <a 
            href="https://www.youtube.com/watch?v=7Cu-JBy_Sr4" 
            target="_blank" 
            rel="noopener noreferrer" 
            class="ml-2 text-blue-500 hover:underline"
          >
            Click Here!
          </a>
          </label>
        </div>

        <div>
          <label>Name of the Office</label>
          <input
            type="text"
            id="officeName"
            name="officeName"
            value={formData.officeName}
            onChange={handleInputChange}
          />
        </div>

        <div>
          <label>Name of Employee</label>
          <input
            type="text"
            id="employeeName"
            name="employeeName"
            value={formData.employeeName}
            onChange={handleInputChange}
          />
        </div>

        <div>
          <EmailInput name="email" value={formData.email} onChange={handleInputChange} />
        </div>

        <div>
          <PhoneNumberInput name="phoneNumber" value={formData.phoneNumber} onChange={handleInputChange} />
        </div>

        <div>
          <label>Gender:</label>
          <RadioButtonInput
            value={formData.gender}
            name="gender"
            orientation="horizontal"
            options={[
              { value: 'male', label: 'Male' },
              { value: 'female', label: 'Female' },
            ]}
            onChange={handleInputChange}
          />
        </div>

        <div>
          <label>Designation</label>
          <input
            type="text"
            id="designation"
            name="designation"
            value={formData.designation}
            onChange={handleInputChange}
          />
        </div>

        <div>
          <label>Handicap:</label>
          <RadioButtonInput
            value={formData.handicapped}
            name="handicapped"
            orientation="horizontal"
            options={[
              { value: 'Yes', label: 'Yes' },
              { value: 'No', label: 'No' },
            ]}
            onChange={handleInputChange}
          />
        </div>

        <div>
          <label>Professional Tax:</label>
          <RadioButtonInput
            value={formData.professionalTax}
            name="professionalTax"
            orientation="horizontal"
            options={[
              { value: 'Yes', label: 'Yes' },
              { value: 'No', label: 'No' },
            ]}
            onChange={handleInputChange}
          />
        </div>

        <div>
          <label>End Date of Arrears</label>
          <input
            type="date"
            id="arrearsEndDate"
            name="arrearsEndDate"
            value={formData.arrearsEndDate}
            onChange={handleInputChange}
          />
        </div>

        <div>
          <label>City:</label>
          <select
            id="city"
            name="city"
            value={formData.city || ''}
            onChange={handleInputChange}
          >
            <option value="" disabled>Select City</option>
            <option value="X">X</option>
            <option value="Y">Y</option>
            <option value="Y-Nagpur">Y-Nagpur</option>
            <option value="Z">Z</option>
          </select>
        </div>

        {/* Dynamic Tables */}
        <DynamicTable2
          tableName="Salary Details: (start date of arrears is fixed to 01/07/2024)"
          columns={[
            { header: "Date", key: "date", type: "date", disableFirstRow: true },
            { header: "Basic Pay",name: "basicPay", key: "basicPay", type: "number" },
            {
              header: "Pay Level",
              name: "payLevel",
              key: "payLevel",
              type: "dropdown",
              options: [
                "S-1", "S-2", "S-3", "S-4", "S-5", "S-6", "S-7", "S-8", "S-9", "S-10", "S-11", "S-12",
                "S-13", "S-14", "S-15", "S-16", "S-17", "S-18", "S-19", "S-20", "S-21", "S-22", "S-23", "S-24",
                "S-25", "S-26", "S-27", "S-28", "S-29", "S-30", "S-31",
                "AL-10", "AL-11", "AL-12", "AL-13A", "AL-14", "AL-15",
              ],
            },
          ]}
          localStorageKey="SalaryDetails"
          rows={formData.SalaryDetails}
          onTableDataChange={onTableDataChange("SalaryDetails")}
  
        />

        {/* Submit Button with Loader */}
        <button
        className="single-button submit-button gap-2 px-4 py-2 text-white rounded-lg flex items-center justify-center disabled:opacity-60 disabled:cursor-not-allowed relative"
        type="submit"
        disabled={isSubmitting}
      >
        {isSubmitting && <Loader className="animate-spin mr-2" />}
        {isSubmitting ? "Submitting..." : "Submit"}
      </button>

      </form>
    </div>
     {/* Place outside of the main container so it overlays entire screen */}
     {PaymentWindowComponent}
  </>
  );
}

export default DaArrearsForm;
